// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import {
  connectGoogleGmail,
  disconnectGoogleGmail,
  getAuthUrlGoogle,
  getTokenGoogle,
  getListGoogleGmail,
  sendGoogleGmail,
} from './googleThunk';
import { EMPTY_STRING } from '~/utils/constants/common';

export interface GoogleState {
  nextPageToken?: string;
}

const initialState: GoogleState = {
  nextPageToken: EMPTY_STRING,
};

const googleSlice = createSlice({
  name: 'google',
  initialState,
  reducers: {
    setNextPageToken(state, action) {
      state.nextPageToken = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Get Auth Url
    builder
      .addCase(getAuthUrlGoogle.pending, (state) => {})
      .addCase(getAuthUrlGoogle.fulfilled, (state, action) => {})
      .addCase(getAuthUrlGoogle.rejected, (state) => {});

    // Get Token
    builder
      .addCase(getTokenGoogle.pending, (state) => {})
      .addCase(getTokenGoogle.fulfilled, (state, action) => {})
      .addCase(getTokenGoogle.rejected, (state) => {});

    // Connect Google Gmail
    builder
      .addCase(connectGoogleGmail.pending, (state) => {})
      .addCase(connectGoogleGmail.fulfilled, (state, action) => {})
      .addCase(connectGoogleGmail.rejected, (state) => {});

    // Disconnect
    builder
      .addCase(disconnectGoogleGmail.pending, (state) => {})
      .addCase(disconnectGoogleGmail.fulfilled, (state, action) => {})
      .addCase(disconnectGoogleGmail.rejected, (state) => {});

    // Get List Google Gmail
    builder
      .addCase(getListGoogleGmail.pending, (state) => {})
      .addCase(getListGoogleGmail.fulfilled, (state) => {})
      .addCase(getListGoogleGmail.rejected, (state) => {});

    // Send Gmail
    builder
      .addCase(sendGoogleGmail.pending, (state) => {})
      .addCase(sendGoogleGmail.fulfilled, (state) => {})
      .addCase(sendGoogleGmail.rejected, (state) => {});
  },
});

export const googleActions = googleSlice.actions;

const googleReducer = googleSlice.reducer;

export default googleReducer;
